import { INSTRUCTION_ANIMATIONS } from '../../instructionAnimations';

import type { InstructionAnimation } from '../../instructionAnimations';

export type InstructionStage = 'leftRight' | 'up' | 'space' | 'done';

export function getInstructionAnimation(
	stage: InstructionStage,
	useSwipeInstructions: boolean,
): InstructionAnimation | null {
	if (stage === 'done') {
		return null;
	}

	if (useSwipeInstructions) {
		if (stage === 'leftRight') {
			return INSTRUCTION_ANIMATIONS.swipeLeft;
		}
		if (stage === 'up') {
			return INSTRUCTION_ANIMATIONS.swipeUp;
		}
		return INSTRUCTION_ANIMATIONS.tap;
	}

	if (stage === 'leftRight') {
		return INSTRUCTION_ANIMATIONS.leftRightKey;
	}
	if (stage === 'up') {
		return INSTRUCTION_ANIMATIONS.upKey;
	}
	return INSTRUCTION_ANIMATIONS.spaceKey;
}

export function getInstructionTooltipKey(stage: InstructionStage, useSwipeInstructions: boolean): string | null {
	if (stage === 'done') {
		return null;
	}

	if (useSwipeInstructions) {
		if (stage === 'leftRight') {
			return 'lane_chooser.hints.swipe_left';
		}
		if (stage === 'up') {
			return 'lane_chooser.hints.swipe_up';
		}
		return 'lane_chooser.hints.tap';
	}

	if (stage === 'leftRight') {
		return 'lane_chooser.hints.press_left_right';
	}
	if (stage === 'up') {
		return 'lane_chooser.hints.press_up_or_down';
	}
	return 'lane_chooser.hints.press_space';
}
